// extracted by mini-css-extract-plugin
module.exports = {"options":"Options_options__3qyop","delete":"Options_delete__1x92z","delete-spinner":"Options_delete-spinner__3_FhP","save":"Options_save__1_zTh","invalid":"Options_invalid__33JTS"};